module.exports = __webpack_public_path__ + "media/site/images/startups/jedziemyrazem-desktop-dbd2ec98ffcf9897114b3fc71f7210f8.png";